var path = 'alarm/alarm-header.tpl.html';
var html = "\n<div translate class=\"tb-cell\" flex=\"30\">alarm.created-time</div>\n<div translate class=\"tb-cell\" flex=\"15\">alarm.originator</div>\n<div translate class=\"tb-cell\" flex=\"20\">alarm.type</div>\n<div translate class=\"tb-cell\" flex=\"15\">alarm.severity</div>\n<div translate class=\"tb-cell\" flex=\"20\">alarm.status</div>\n<div translate class=\"tb-cell\" flex=\"15\">alarm.details</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/alarm/alarm-header.tpl.html
// module id = 1375
// module chunks = 1